export default {"src":"/_next/static/media/Illustration-create.17254610.svg","height":402,"width":456,"blurWidth":0,"blurHeight":0};